import styled from 'styled-components'

import Background from '../Background'

const Card = styled(Background).attrs({ type: 'white' })`
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 8px;
    border: 1px solid ${props => props.theme.colors.gray200};
    overflow: hidden;
    background: ${props => props.theme.colors.white};

    @media (max-width: 767.9px) {
        border-radius: 0px;
    }
`

export default Card